var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterestsNote = function SvgInterestsNote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "interests-note_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".interests-note_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 2.5h18c.6 0 1 .4 1 1v19c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1v-19c0-.6.4-1 1-1M6 4.5v-4M18 4.5v-4M10 4.5v-4M14 4.5v-4",
    className: "interests-note_svg__st0"
  })));
};
export default SvgInterestsNote;